import { render } from "./TheVehicleCommands.vue?vue&type=template&id=6cd4f624"
import script from "./TheVehicleCommands.vue?vue&type=script&lang=js"
export * from "./TheVehicleCommands.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__